// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.91.0/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.91.0/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `div[role='dialogRoot'] .local-modal-pro {
  z-index: 9999;
}
div[role='dialogRoot'] .local-modal-pro .wui-modal-content {
  -webkit-transform: unset !important;
          transform: unset !important;
  margin: 100px auto !important;
  position: unset !important;
}
div[role='dialogRoot'] .local-modal-pro .wui-modal-content .img_box_item {
  padding: 8px;
  color: white;
  display: inline-block;
}
div[role='dialogRoot'] .local-modal-pro .wui-modal-content .img_box_item .img-description {
  position: relative;
  max-width: 100px;
  color: #000;
  min-height: 18px;
  max-height: 32px;
  line-height: 16px;
  text-overflow: ellipsis;
  overflow: hidden;
  word-wrap: break-word;
}
div[role='dialogRoot'] .local-modal-pro .wui-modal-content .img_box_item .img-description .delete-button {
  display: none;
  position: absolute;
  width: 40px;
  height: 16px;
  right: 0;
  top: 2px;
  background-image: linear-gradient(to right, rgba(255, 255, 255, 0) 0, #f4f5f7 100%);
  text-align: right;
}
div[role='dialogRoot'] .local-modal-pro .wui-modal-content .img_box_item .img-description .delete-button .icon-delete {
  width: 16px;
  height: 16px;
  cursor: pointer;
}
div[role='dialogRoot'] .local-modal-pro .wui-modal-content .img_box_item:hover {
  background: #f0f0f0;
  border-radius: 8px;
}
div[role='dialogRoot'] .local-modal-pro .wui-modal-content .img_box_item:hover .delete-button {
  display: block;
}
div[role='dialogRoot'] .local-modal-pro .wui-modal-content .lock-box {
  display: inline-block;
  height: 30px;
  cursor: not-allowed;
}
div[role='dialogRoot'] .local-modal-pro .wui-modal-content .lock-box i {
  position: relative;
  top: 4px;
}
`, "",{"version":3,"sources":["webpack://./src/components/Editor/src/components/LocalModal/index.less"],"names":[],"mappings":"AAAA;EAEQ,aAAA;AAAR;AAFA;EAKY,mCAAA;UAAA,2BAAA;EACA,6BAAA;EACA,0BAAA;AAAZ;AAPA;EAUgB,YAAA;EACA,YAAA;EACA,qBAAA;AAAhB;AAZA;EAeoB,kBAAA;EACA,gBAAA;EACA,WAAA;EACA,gBAAA;EACA,gBAAA;EACA,iBAAA;EACA,uBAAA;EACA,gBAAA;EACA,qBAAA;AAApB;AAvBA;EA0BwB,aAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,QAAA;EACA,QAAA;EACA,mFAAA;EACA,iBAAA;AAAxB;AAjCA;EAoC4B,WAAA;EACA,YAAA;EACA,eAAA;AAA5B;AAKgB;EACI,mBAAA;EACA,kBAAA;AAHpB;AACgB;EAKQ,cAAA;AAHxB;AA7CA;EAsDgB,qBAAA;EACA,YAAA;EACA,mBAAA;AANhB;AAlDA;EA2DoB,kBAAA;EACA,QAAA;AANpB","sourcesContent":["div[role='dialogRoot'] {\n    .local-modal-pro {\n        z-index: 9999;\n\n        .wui-modal-content {\n            transform: unset !important;\n            margin: 100px auto !important;\n            position: unset !important;\n\n            .img_box_item {\n                padding: 8px;\n                color: white;\n                display: inline-block;\n\n                .img-description {\n                    position: relative;\n                    max-width: 100px;\n                    color: #000;\n                    min-height: 18px;\n                    max-height: 32px;\n                    line-height: 16px;\n                    text-overflow: ellipsis;\n                    overflow: hidden;\n                    word-wrap: break-word;\n\n                    .delete-button {\n                        display: none;\n                        position: absolute;\n                        width: 40px;\n                        height: 16px;\n                        right: 0;\n                        top: 2px;\n                        background-image: linear-gradient(to right, rgba(255, 255, 255, 0) 0, #f4f5f7 100%);\n                        text-align: right;\n\n                        .icon-delete {\n                            width: 16px;\n                            height: 16px;\n                            cursor: pointer;\n                        }\n                    }\n                }\n\n                &:hover {\n                    background: #f0f0f0;\n                    border-radius: 8px;\n\n                    .delete-button {\n                        display: block;\n                    }\n                }\n            }\n\n            .lock-box {\n                display: inline-block;\n                height: 30px;\n                cursor: not-allowed;\n\n                i {\n                    position: relative;\n                    top: 4px;\n                }\n            }\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
